import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_API_SUCCESS,
  DELETE_API_SUCCESS,
  GET_API_FAIL,
  GET_API_SUCCESS,
  UPDATE_API_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  apiusers: [],

  error: {},
};

const API = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_API_SUCCESS:
      return {
        ...state,
        apiusers: action.payload.apiusers,
      };

    case GET_API_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_API_SUCCESS:
      return {
        ...state,
        apiusers: [...state.apiusers, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_API_SUCCESS:
      return {
        ...state,
        apiusers: state.apiusers.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_API_SUCCESS:
      return {
        ...state,
        apiusers: state.apiusers.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default API;
